import {
  CREATE_SYSTEM_REQUEST_COMMON,
  GET_SITE_DETAILS,
  SITE_SEARCH_REQUEST_COMMON,
} from './constants';

export function createSystem(payload) {
  return { type: CREATE_SYSTEM_REQUEST_COMMON, payload };
}

export function getSearchResult(payload) {
  return { type: SITE_SEARCH_REQUEST_COMMON, payload };
}

export function getSiteDetails(payload) {
  return { type: GET_SITE_DETAILS, payload };
}
